import angular from 'angular';

export class EnlargeImageDirective {
    constructor(Lightbox) {
        this.restrict = 'A';
        this.scope = {};
        this.Lightbox = Lightbox;
    }

    enlargeImageController($scope, $state) {
        $scope.state = $state;
    }

    link(scope, element, attrs) { 
        const el = window.$(element);
        const src = el.attr('src');
        
        el.on('click', () => { 
            this.Lightbox.openModal([{ url: src }], 0);
        });
    }
}

EnlargeImageDirective.$inject = ['Lightbox'];

angular.module('syncplicity-login.directives', [])
  .directive('enlargeImage', ['Lightbox', function(Lightbox){return new EnlargeImageDirective(Lightbox)}]);



// WEBPACK FOOTER //
// ./client/components/directives/enlarge-image/enlarge-image.js